




















import Component from 'vue-class-component'
import BaseError from './BaseError'
import {Mutation} from 'vuex-class'
import {StoreNamespace} from '../../globals/StoreNamespaceGlobal'

@Component({})
export default class UnauthorizedErrorComponent extends BaseError {

    @Mutation('resetState', StoreNamespace.LOBBY) resetState: any

    resetAndGoToLobby(): void {
        this.resetState()
        this.goToLobby()
    }
}
